export default __webpack_public_path__ + "static/media/JOSA CLASS-10 EXAM PATTERN 2025.6d37a54f.pdf";